import { http } from '@king-fisher/mobileweb-lib';
import { APP_ID } from './constants';

type ResponseResult<DataType = unknown> = Promise<{
  status_code: number;
  status_msg: string;
  data: DataType;
}>;

const BASE_SUB_URL = '//push.10jqka.com.cn/content_subscription';
const BASE_PUSH_URL = '//push.10jqka.com.cn/switch';

/**
 * 查询栏目的订阅状态
 * @see https://yapi.myhexin.com/yapi/service/328673/interface/api/787688
 *
 * @param { number } columnId - 栏目ID
 */
export function fetchSubscriptionStatus(
  columnId: number
): ResponseResult<{ column_id: number; subscription_status: 0 | 1 }> {
  return http(`${BASE_SUB_URL}/subscription_service/v1/status?column_id=${columnId}`);
}

/**
 * 更新栏目的订阅状态，
 * @see https://yapi.myhexin.com/yapi/service/328673/interface/api/787686
 *
 * @param { number } column_id - 栏目ID
 * @param { 0 | 1 } subscription_behavior - 订阅行为，1表示订阅，0表示取消订阅
 */
export function updateSubscriptionStatus(
  column_id: number,
  subscription_behavior: 0 | 1
): ResponseResult<{ push_status: 0 | 1 }> {
  return http(`${BASE_SUB_URL}/subscription_service/v1/subscribe`, {
    method: 'POST',
    data: {
      column_id,
      subscription_behavior,
    },
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

/**
 * 设置栏目的push开关
 * @see https://yapi.myhexin.com/yapi/service/310231/interface/api/43841
 *
 * @param { number } cateid - 栏目ID，跟订阅的column_id一致
 * @param { 'open' | 'close' } action - 操作类型，'open'表示开启推送，'close'表示关闭推送
 */
export function setPushSwitch(cateid: number, action: 'open' | 'close' = 'open'): ResponseResult<null> {
  return http(`${BASE_PUSH_URL}/cate?appid=${APP_ID}&action=${action}&cateid=${cateid}`);
}
